<template>
   <Breadcrumbs title="Layout Light"/>
    <div class="container-fluid">
            <div class="row starter-main">
              <BackendHealthCard />
            </div>
    </div>
</template>
<script>
import BackendHealthCard from '@/components/dashboard/BackendHealthCard.vue';

export default {
        components:{
          BackendHealthCard,
        }
}
</script>